import React from 'react';
import { strategies } from '../data/strategies';
export function TickerMarquee() {
  // Duplicate the strategies array to create a seamless loop
  const tickerItems = [...strategies, ...strategies];
  return <div className="w-full bg-base-950 border-y border-slate-800/50 overflow-hidden py-3 relative flex items-center" data-id="element-289">
      {/* Gradient masks for smooth fade on edges */}
      <div className="absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-base-950 to-transparent z-10" data-id="element-290"></div>
      <div className="absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-base-950 to-transparent z-10" data-id="element-291"></div>

      <div className="flex whitespace-nowrap animate-marquee" data-id="element-292">
        {tickerItems.map((strategy, index) => <div key={`${strategy.id}-${index}`} className="flex items-center mx-6" data-id="element-293">
            <span className="text-slate-300 font-medium tracking-wider uppercase text-xs mr-3" data-id="element-294">
              {strategy.title}
            </span>
            <span className="text-slate-600 font-mono text-xs" data-id="element-295">
              {strategy.tickers}
            </span>
            <span className="mx-6 text-slate-800 text-xs" data-id="element-296">·</span>
          </div>)}
      </div>
    </div>;
}